import React from "react";
import { useTranslation } from "react-i18next";
import { View } from "@/styles/reactnative";

const OrderPreferenceNote = () => {
  const { t } = useTranslation();
  return (
    <View
      style={{
        width: "100%",
        alignItems: "flex-start",
        background: '#1a1c1b',
        borderRadius: 8,
        marginTop: 20,
        padding: 12,
      }}
    >
      <View style={{ flexDirection: "row", alignItems: "flex-start" }}>
        <span
          style={{
            color: "#f7465b",
            marginRight: 5,
            fontSize: 12,
            fontWeight: 700,
            fontFamily: 'NanumSquareRound',
          }}
        >
          *
        </span>
        <span
          style={{
            fontSize: 12,
            fontWeight: 700,
            color: '#fff',
            letterSpacing: '-0.36px',
            fontFamily: 'NanumSquareRound',
          }}
        >
          {t("note")}
        </span>
      </View>
      <div
        style={{
          fontSize: 12,
          fontWeight: 400,
          color: '#b3b5bd',
          letterSpacing: '-0.36px',
          fontFamily: 'NanumSquareRound',
          lineHeight: 1.5,
          marginTop: 6,
        }}
      >
        {t("orderNoteDesc")}
      </div>
    </View>
  );
};

export default OrderPreferenceNote;
